<div class="container">
  <header class="header">
    <app-page-close-button (click)="goBack()"></app-page-close-button>
    <div class="title">Agreement {{ currentAgreementId ? 'Update' : 'Creation' }} & Configuration</div>
  </header>

  <div class="content">
    <div class="card">
      <div class="form" [ngClass]="{section_disabled: !customerAgreementEditEnabled}">
        <app-file-upload
          [disabled]="!customerAgreementEditEnabled"
          [multiFileUpload]="true"
          [(files)]="selectedFiles"
        ></app-file-upload>
        <app-dynamic-form
          [formConfig]="customerAgreementFormConfig"
          [formGroup]="customerAgreementForm"
        ></app-dynamic-form>
        <div class="action_buttons" *ngIf="customerAgreementEditEnabled">
          <button class="secondary_button" (click)="goBack()">Cancel</button>
          <button class="primary_button" (click)="save()">
            {{ currentAgreementId ? 'Update' : 'Save' }}
          </button>

        </div>
      </div>
      <div class="vertical_divider"></div>
      @if (isLoading) {
        <div class="configurations_list">
          <app-skeleton-loader [count]="25"></app-skeleton-loader>
        </div>
      } @else {
        <div class="configurations_list" [ngClass]="{section_disabled: !configurationsEditEnabled}">
          @if (!customerAgreementData?.agreementConfigurations) {
            <div class="no_data">
              <app-no-data
                [path]="!configurationsEditEnabled ? 'assets/images/no_configuration_disabled.svg' : 'assets/images/no_configuration.svg'"
                [msg]="'No Agreements has been created, add the contracts to view it'"></app-no-data>
              <button class="btn tertiary_button" [disabled]="!configurationsEditEnabled"
                      (click)="createNewAgreementConfiguration()">
                <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
                Add Configuration
              </button>
            </div>
          } @else {
            <div class="configurations_header">
              <div class="title">Agreement Configurations</div>
              <button class="btn tertiary_button" (click)="createNewAgreementConfiguration()">
                <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
                Add Configuration
              </button>
            </div>
            <app-static-table
              [tableMeta]="agreementConfigurationListingConfig"
              [data]="customerAgreementData?.agreementConfigurations || []"
              [showSerialNumber]="false"
              [deleteAllowed]="false"
              [editAllowed]="false"
              (rowActionTriggered)="handleRowAction($event)"
            ></app-static-table>
          }
        </div>
      }

    </div>
  </div>
</div>

<ng-template #cloneAgreementConfigForm let-data>
  <div class="clone_form_modal_content">
    <small>Please provide a description for the newly cloned agreement.</small>
    <form [formGroup]="cloneAgreementForm">
      <div class="form_row">
        <div class="form_group">
          <label class="" for="description">Description</label>
          <textarea formControlName="description" id="description" placeholder="Enter description"></textarea>
        </div>
      </div>
    </form>
    <div class="action_btns">
      <div class="btn secondary_button">Cancel</div>
      <div class="btn primary_button" (click)="cloneAgreementConfiguration(data.record)">Save</div>
    </div>
  </div>
</ng-template>

